module.exports = __webpack_public_path__ + "img/B001_R_home slider.1a38f7ec.jpg";